import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  AfterViewInit,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { FormService } from '../../../shared/form.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ValidationService } from '../../../services/validation.service';
import { TrackService } from 'src/app/services/track.service';
import { ProposalService } from 'src/app/shared/proposal.service';
import { MapTrackingService } from 'src/app/services/mapTracking.service';
import { RadioButtonComponent } from 'qbe-components';
import { Validators } from '@angular/forms';

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-details1',
  templateUrl: './details1.component.html',
  styleUrls: ['./details1.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class Details1Component implements OnInit, AfterContentInit {
  @ViewChild('mypanel') myPanel: QueryList<any>;
  public nonStrictDate = moment();
  public openedNonStrict = false;
  public currentLocale: string;

  inputString = '2020-01-01';

  parentForm;
  selectedType = '1';
  startAt = null;
  public parseFormat = ['YYYY'];
  public parseFormatYear = ['YYYY'];
  maxDate = moment().format('YYYY');
  minDate = moment(1900, 'YYYY');
  radio
  gmapsSelectAddress
  @ViewChild('radioBtnAddress') radioBtnAddress: RadioButtonComponent;
  // purposeLast;
  // postCodeLast;
  // constructuinYearLast;

  constructor(
    public formService: FormService,
    public validationService: ValidationService,
    public sharedService: SharedService,
    public proposalService: ProposalService,
    private elRef: ElementRef,
    public trackService: TrackService,
    public mapTrackService: MapTrackingService,
    private ch: ChangeDetectorRef
  ) {}

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  selectBrand(selection) {
    this.parentForm.get('vehicleDTO.makeId').setValue(selection, {
      onlySelf: true,
      emitEvent: false,
      emitModelToViewChange: true,
    });
  }
  checkRadio(){
    console.log(this.radio);
  }
  chosenYearHandler(normalizedYear: Moment, datepicker?: any) {
    this.trackService.addAttribute(
      'propertyDetails.buildYear',
      '' + normalizedYear.year()
    );

    this.parentForm.controls.yearOfConstruction.setValue(
      '' + normalizedYear.year()
    );
    this.parentForm.controls.yearOfConstruction.setErrors(null);
    if (datepicker) {
      datepicker.close();
    }


  }

  isCheckedAddress(address){
    if(this.formService.currentForm.get('fullAddress').value && address){
     return JSON.stringify(this.formService.currentForm.get('fullAddress').value) === JSON.stringify(address)
    }
    else return false;
  }

  ngAfterContentInit() {
    const year = this.parentForm.controls.yearOfConstruction._pendingValue;
    if (year) {
      if (year < 1900) {
        this.parentForm.controls.yearOfConstruction.setErrors({
          incorrect: true,
        });
        return;
      }
      setTimeout(() => {
        this.chosenYearHandler(moment(year, 'YYYY'));
      });
    } else {
      this.startAt = moment(2015, 'YYYY');
    }
  }

  ngOnInit(): void {
    document.querySelector('.qbe-button').setAttribute('disabled', 'true');
    this.parentForm = this.formService.currentForm;
    this.sharedService.previousStepNumber = '02';
    this.sharedService.previousStepName = 'object-details';

    this.sharedService.gmapsSelectAddress$.subscribe(res => {
      if(res) {
        this.gmapsSelectAddress = res;
        this.ch.detectChanges();
      }
    } )


    this.validateBlockStreet('block');
    this.validateBlockStreet('streetNumber')

  }
  setAddress(address) {
    this.formService.currentForm.get('fullAddress').setValue(address);
    const {longitude, latitude , placeId, postCode} = this.formService.currentForm.get('fullAddress').value
    this.formService.currentForm.get('longitude').setValue(longitude)
    this.formService.currentForm.get('latitude').setValue(latitude)
    this.formService.currentForm.get('placeId').setValue(placeId)
  }
  setDigitalDataPurpose(value) {
    // let purposeNames = ['permanentPlace', 'vacationPlace'];
    // if(value && (this.purposeLast != value)) {
    //   window['qbhome'].push({
    //         process: {
    //           name: 'propertyDetails.purpose',
    //           value: purposeNames[value-1],
    //           type: 'once',
    //           mode: 'add/remove'
    //         }
    //   });
    // }
    //this.purposeLast = value;
  }

  setDigitalDataPostCode(value) {
    // if(value && (this.postCodeLast != value)) {
    //   window['qbhome'].push({
    //         process: {
    //           name: 'userDetails.sortCode',
    //           value: value,
    //           type: 'once',
    //           mode: 'add/remove'
    //     }
    //   });
    // }
    // this.postCodeLast = value;
  }

  // get yearOfConstruction(): any {
  //   return this.parentForm.get('yearOfConstruction');
  // }

  // checkifTouched() {
  //   console.log(this.yearOfConstruction.invalid);
  // }

  setDigitalDataConstructionYear(value) {
    if (typeof value === 'string') {
      let year = +value;
      value = moment(year, 'YYYY');
    }
    if (value == null) {
      return;
    }
    if (value.year() > this.maxDate || value.year() < this.minDate.year()) {
      this.parentForm.controls.yearOfConstruction.patchValue('' + value.year());
      this.parentForm.controls.yearOfConstruction.setErrors({
        incorrect: true,
      });
      return;
    }
    this.trackService.addAttribute('propertyDetails.buildYear', value.year());
    this.parentForm.controls.yearOfConstruction.patchValue('' + value.year());
    this.parentForm.controls.yearOfConstruction.setErrors(null);
  }

  setCity(postCode, town) {
    this.proposalService.setOwnerData(postCode, town);
  }
  validateBlockStreet(chnagedInput){
    if (this.formService.currentForm.get('propertyCategory').value === '2') {
      if (this.formService.currentForm.get('block').value !== '') {
        this.formService.currentForm.get('apartment').setValidators(Validators.required);
        this.formService.currentForm.get('entrance').setValidators(Validators.required);
        this.formService.currentForm.get('floor').setValidators(Validators.required);
        this.formService.currentForm.get('apartment').updateValueAndValidity();
        this.formService.currentForm.get('entrance').updateValueAndValidity();
        this.formService.currentForm.get('floor').updateValueAndValidity();
        this.validationService.registerControl(this.formService.currentForm.get('entrance'));
        this.validationService.registerControl(this.formService.currentForm.get('floor'));
        this.validationService.registerControl(this.formService.currentForm.get('apartment'));
      } else {
        this.formService.currentForm.get('apartment').clearValidators();
        this.formService.currentForm.get('entrance').clearValidators();
        this.formService.currentForm.get('floor').clearValidators();
        this.formService.currentForm.get('apartment').updateValueAndValidity();
        this.formService.currentForm.get('entrance').updateValueAndValidity();
        this.formService.currentForm.get('floor').updateValueAndValidity();
      }
    }
    if(chnagedInput=='block'){
      if(this.formService.currentForm.get('block').value!==''){
        this.formService.currentForm.get('streetNumber').clearValidators();
        this.formService.currentForm.get('streetNumber').updateValueAndValidity();
      }
      else {
        if(this.formService.currentForm.get('streetNumber').value==''){
          this.formService.currentForm.get('block').addValidators(Validators.required);
          this.formService.currentForm.get('block').updateValueAndValidity();
        }
        else{
          this.formService.currentForm.get('block').clearValidators();
          this.formService.currentForm.get('block').updateValueAndValidity();
        }
      }
    }
    else{
      if(this.formService.currentForm.get('streetNumber').value!==''){
        this.formService.currentForm.get('block').clearValidators();
        this.formService.currentForm.get('block').updateValueAndValidity();
      }
      else {
        if(this.formService.currentForm.get('block').value==''){
          this.formService.currentForm.get('streetNumber').addValidators(Validators.required);
          this.formService.currentForm.get('streetNumber').updateValueAndValidity();
        }
        else{
          this.formService.currentForm.get('streetNumber').clearValidators();
        this.formService.currentForm.get('streetNumber').updateValueAndValidity();
        }
      }
    }
  }
}
